import React, { forwardRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaRegCopy } from 'react-icons/fa';

import { useAppContext } from '../../../context/AppContext';
import useLocalization from '../../../hooks/useLocalization';

import BotErrorBox from './BotResponseComponent/BotErrorBox';
import BotResponseText from './BotResponseComponent/BotResponseText';
import GrievanceInfoCard from './BotResponseComponent/GrievanceInfoCard';
import ImageResponse from './BotResponseComponent/ImageResponse';
import BotTableRenderer from './BotResponseComponent/BotTableRenderer';
import AudioResponsePlayer from './BotResponseComponent/AudioResponsePlayer';
import StatusAnimator from './BotResponseComponent/StatusAnimator';
import LanguageDetector from './BotResponseComponent/LanguageDetector';
import { useLogger } from '../../../utils/UnifiedLogger';
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";


import {
  setInputDisabled,
  setInputValue,
  setMicButtonDisabled,
  setSendButtonDisabled,
} from "../../../store/features/ui/uiSlice";
import { selectSelectedChatId } from '../../../store/features/message/textContentSelectors';
import { setIsHideUserInputFields, unlockTextFlowForChat, unlockVoiceFlowForChat } from '../../../store/features/message/textContentSlice';
import { updateFlowStates } from '../../../store/features/message/updateFlowStates';
import BotErrorMessage from './BotResponseComponent/BotErrorMessage';
import GrivanceNotRelatedToCpgram from './BotResponseComponent/GrivanceNotRelatedToCpgram';
import GrievanceNotRelatedToCentral from './BotResponseComponent/GrievanceNotRelatedToCentral';
import VerifyDataModal from './BotResponseComponent/VerifyDataModel/VerifyDataModal';
import BotDynamicForm from './BotResponseComponent/BotDynamicForm/BotDynamicForm';

const BotChatHead = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { logInfo } = useLogger("BOT_CHAT_HEAD", false);
  const {
    selectedLanguageData,
    userData,
    // isVoiceFlowLocked
  } = useAppContext();
  const selectedChatId = useSelector(selectSelectedChatId);
  // const isVoiceFlowLocked = useSelector(selectIsVoiceFlowLocked(selectedChatId));
  // const isTextFlowLocked = useSelector(selectIsTextFlowLocked(selectedChatId));
  // const isVoiceFlow = useSelector(selectIsVoiceFlow);
  // const isTextFlow = useSelector(selectIsTextFlow);

  const { t } = useLocalization();
  const [showText, setShowText] = useState(true);

  // input states from Redux

  const {
    response = {},
    onRegenerate,
    onCopy,
    timestamp = '',
    botImage = '',
    identificationClassName = '',
    hasSubmitted,
    handleSubmitGrievance,
    setFormAnswers,
    setFilledForms,
    onDynamicFormSubmit,
    setDynamicFormSubmit,
    isMostRecent = false,
    handleSend,
  } = props;

  const {
    contentAudio = '',
    text = '',
    contentStandard = '',
    imageUrl = '',
    tableData = [],
    mandatory_data_present,
    mandatory_questions_answered,
    mandatory_questions_asked,
    grievance_bucket,
    updated_grievance = '',
    botResponse,
    isLanguageDetecting = false,
    isBotResponding = false,
    languageDetectedMessage = '',
    isError = false,
    field_form = {},
    nerContent,
    isNerResponding,
    apiProgressData,
    category_code = null,
    org_code = "",
    field_form_list = [],
    isVoiceFlow = false,
    isTextFlow = false,
    errorMessage = "",
    isErrorMessage = false,
    isNotRelatedToGrievance = false,
    isNotRelatedToCenter = false,
    serverRemarks = "",
  } = response;

  const isVoiceFlowLocked = isVoiceFlow;
  const isTextFlowLocked = isTextFlow;


  const isFieldFormContainsData = () => {
    const isValidForm =
      field_form &&
      typeof field_form === "object" &&
      !field_form.error &&
      !field_form.status_code &&
      Array.isArray(field_form.InputFields) &&
      field_form.InputFields.length > 0;
    return isValidForm;
  };

  // const isUserAnsweredTheFormData = () => {
  //   const isValidForm =
  //     field_form_list &&
  //     Array.isArray(field_form_list) &&
  //     field_form_list.length > 0;
  //   return isValidForm;
  // };

  // ✅ Show form only when mandatory data not present & valid form exists
  const shouldShowDynamicForm = !isVoiceFlow && !isVoiceFlowLocked && !mandatory_data_present && isFieldFormContainsData() && !isNotRelatedToGrievance && !isNotRelatedToCenter;
  const isValidResponseText = typeof text === "string" && text.trim().length > 0 && contentStandard.toLowerCase().trim() !== "only form fields" && !isNotRelatedToGrievance && !isNotRelatedToCenter;
  const shouldShowTextResponse = (isVoiceFlow || isVoiceFlowLocked) ? true : isValidResponseText ? true : false;

  // const isChatLocked = isCurrentChatLocked(selectedChatId);
  // logInfo('RENDERING_BOT_CHAT_HEAD', 'Rendering BotChatHead with props:', { props, selectedChatId });



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});


  useEffect(() => {
    const shouldHide =
      isNotRelatedToGrievance ||
      isNotRelatedToCenter ||
      isErrorMessage;
    // dispatch(setIsHideUserInputFields(shouldHide));
    // console.log(`shouldHide: ${shouldHide}`);
    dispatch(setInputDisabled(shouldHide));
    dispatch(setSendButtonDisabled(shouldHide));
    dispatch(setMicButtonDisabled(shouldHide));
  }, [
    isNotRelatedToGrievance,
    isNotRelatedToCenter,
    isErrorMessage,
    dispatch
  ]);


  useEffect(() => {
    if (shouldShowDynamicForm && !shouldShowTextResponse) {
      dispatch(setIsHideUserInputFields(true));
    } else {
      dispatch(setIsHideUserInputFields(false));
    }
  }, [shouldShowDynamicForm, shouldShowTextResponse, dispatch]);

  const handleCopy = async () => {
    const element = document.getElementById("grievance-content");
    if (element) {
      const htmlToCopy = element.innerHTML;
      const textToCopy = element.innerText;

      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlToCopy], { type: "text/html" }),
          "text/plain": new Blob([textToCopy], { type: "text/plain" }),
        }),
      ]);

      // alert("Grievance details copied!");
    }
  };

  // useEffect(() => {
  //   copyGrievanceDetails();
  // }, [onCopy]);

  const handleSendSelectedText = (selectedText) => {
    logInfo('SELECTED_TEXT_SENT', 'User sent selected text:', { selectedText });
    if (selectedText) {
      dispatch(setInputValue(selectedText));
      dispatch(updateFlowStates());
      handleSend();
    }
  };

  // useEffect(() => {}, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className={`flex items-start w-full max-w-2xl px-2 py-4 mb-10 ${identificationClassName}`}
    >
      <img
        src={botImage}
        alt="Bot"
        className="w-10 h-10 object-cover mt-2 rounded-full hidden sm:block"
      />

      {isError ? (
        <BotErrorBox t={t} onRegenerate={onRegenerate} />
      ) : (
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col flex-1 bg-white w-full dark:bg-[#232323] border border-gray-200 rounded-xl shadow-lg text-gray-900 dark:text-white p-4"
        >
          {/* Language lock indicator and unlock button */}
          {/* {isLanguageLocked && (
            <div className="flex items-center justify-between mb-2 p-2 bg-blue-50 dark:bg-blue-900 rounded-lg">
              <div className="flex items-center space-x-2">
                <span className="text-sm text-blue-600 dark:text-blue-300">
                  🔒 {t('languageLocked')}
                </span>
              </div>
              <button
                onClick={onUnlockLanguage}
                className="text-xs bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded"
                title="Unlock language for next message"
              >
                {t('unlockLanguage')}
              </button>
            </div>
          )} */}

          {
            (isLanguageDetecting || languageDetectedMessage) && (
              <LanguageDetector
                isLanguageDetecting={isLanguageDetecting}
                languageDetectedMessage={languageDetectedMessage}
                detectedLanguage="English"
              />
            )
          }

          {isLanguageDetecting && !isTextFlowLocked && (
            <div className="flex items-center space-x-2 mb-2">
              <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-blue-500"></div>
              <span className="text-xs text-gray-500 dark:text-gray-400">{t('languageDetecting')}</span>
            </div>
          )}

          {isBotResponding && (
            <StatusAnimator nerContent={nerContent} isNerResponding={isNerResponding} isApiResponding={isBotResponding} progressData={apiProgressData} />
          )}

          {(isVoiceFlowLocked || isVoiceFlow) && (
            <AudioResponsePlayer
              isAutoPlay={isMostRecent && (isVoiceFlowLocked || isVoiceFlow)}
              contentAudio={contentAudio}
              showText={showText}
              setShowText={setShowText}
            />
          )}

          {showText && text && !mandatory_data_present && shouldShowTextResponse && !isNotRelatedToGrievance && !isNotRelatedToCenter && (
            <BotResponseText
              text={text}
              onSendSelection={handleSendSelectedText}
            />
          )}

          {
            (text && contentStandard === "only form fields") && (field_form && field_form.InputFields.length === 0) && (
              <div className="text-gray-500 dark:text-gray-400 italic">
                {t('noResponse') || "No text response available."}
              </div>
            )
          }

          {!shouldShowTextResponse && shouldShowDynamicForm && (
            <BotDynamicForm
              field_form={isFieldFormContainsData() ? field_form : {}}
              field_form_list={field_form_list.length > 0 ? field_form_list : []}
              category_code={category_code}
              org_code={org_code}
              formValues={formValues}
              setFormValues={setFormValues}
              errors={errors}
              setErrors={setErrors}
              setFormAnswers={setFormAnswers}
              setFilledForms={setFilledForms}
              onDynamicFormSubmit={onDynamicFormSubmit}
              setDynamicFormSubmit={setDynamicFormSubmit}
            />
          )}

          {mandatory_data_present && grievance_bucket && Object.keys(grievance_bucket).length > 0 && (
            <div id='grievance-content'>
              <GrievanceInfoCard
                field_form_list={field_form_list}
                grievance_bucket={grievance_bucket}
                updated_grievance={updated_grievance}
                selectedLanguageCode={selectedLanguageData?.code || 'en'}
                mandatory_questions_answered={mandatory_questions_answered}
                mandatory_questions_asked={mandatory_questions_asked}
                onVerifyClick={() => {
                  setIsModalOpen(true);
                  if ((isVoiceFlowLocked || isVoiceFlow) && mandatory_data_present === true) {
                    dispatch(unlockVoiceFlowForChat(selectedChatId));
                  }

                  if ((isTextFlowLocked || isTextFlow) && mandatory_data_present === true) {
                    dispatch(unlockTextFlowForChat(selectedChatId));
                  }
                }}
                field_form={isFieldFormContainsData() ? field_form : {}}
                isMostRecent={isMostRecent}
                contentAudio={contentAudio}
                mandatory_data_present={mandatory_data_present}
              />
            </div>
          )}

          <ImageResponse imageUrl={imageUrl} />
          <BotTableRenderer tableData={tableData} />

          <BotErrorMessage isErrorMessage={isErrorMessage} errorMessage={errorMessage} />

          <GrivanceNotRelatedToCpgram isNotRelatedToGrievance={isNotRelatedToGrievance} message={text} />

          <GrievanceNotRelatedToCentral isNotRelated={isNotRelatedToCenter} message={text} />

          {/* {
            console.log(`BotChatHead Render: isTextFlowLocked=${isTextFlowLocked}, isTextFlow=${isTextFlow}, isVoiceFlowLocked=${isVoiceFlowLocked}, isVoiceFlow=${isVoiceFlow}, mandatory_data_present=${mandatory_data_present}, text=${text}`)
          } */}

          {!isVoiceFlow && !isVoiceFlowLocked && (isTextFlowLocked || isTextFlow) &&
            (
              typeof text !== "string" ||
              contentStandard.toLowerCase().trim() !== "only form fields"
            ) && (
              <AudioResponsePlayer
                isAutoPlay={isVoiceFlowLocked && isMostRecent}
                contentAudio={contentAudio}
                showText={showText}
                setShowText={setShowText}
                isLoading={false}
              />
            )}

          <div className="flex items-center justify-between mt-2 border-t pt-3">
            <div className="flex space-x-2">
              <button
                onClick={mandatory_data_present ? handleCopy : onCopy}
                title="Copy"
                className="text-gray-600 hover:text-black dark:text-gray-400 dark:hover:text-white"
              >
                <FaRegCopy />
              </button>
            </div>
            <span className="text-xs text-gray-500 dark:text-gray-400">{timestamp}</span>
          </div>

          {
            isModalOpen && (
              <VerifyDataModal
                category_code={category_code}
                org_code={org_code}
                isOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                onClose={() => setIsModalOpen(false)}
                userData={userData}
                grievance_bucket={grievance_bucket}
                updated_grievance={updated_grievance}
                handleSubmitGrievance={handleSubmitGrievance}
                hasSubmitted={hasSubmitted}
                mandatory_questions_answered={typeof mandatory_questions_answered !== 'string' ? mandatory_questions_answered : []}
                mandatory_questions_asked={typeof mandatory_questions_asked !== 'string' ? mandatory_questions_asked : []}
                mandatory_data_present={mandatory_data_present}
                botResponse={botResponse}
                field_form={field_form}
                field_form_list={field_form_list}
                serverRemarks={serverRemarks}
              />
            )
          }
        </motion.div>
      )}


    </motion.div>
  );
});

BotChatHead.propTypes = {
  response: PropTypes.object,
  onRegenerate: PropTypes.func,
  onCopy: PropTypes.func,
  timestamp: PropTypes.string,
  botImage: PropTypes.string,
  identificationClassName: PropTypes.string,
  hasSubmitted: PropTypes.bool,
  handleSubmitGrievance: PropTypes.func,
  setFormAnswers: PropTypes.func,
  setFilledForms: PropTypes.func,
  onDynamicFormSubmit: PropTypes.bool,
  setDynamicFormSubmit: PropTypes.func,
  isMostRecent: PropTypes.bool,
  handleSend: PropTypes.func,
  // isNotRelatedToCenter: PropTypes.bool,
  // isNotRelatedToGrievance: PropTypes.bool,

};
BotChatHead.displayName = "BotChatHead";
export default BotChatHead;
